// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"117":"b7e7be25","167":"d94bf362","379":"eadcc58f","396":"fe003d4a","576":"f2c7258b","661":"8ef87107","673":"453ae562","693":"5c9bc217","747":"4c1474e9"}[chunkId] + ".js";
};